// Lightweight client-side SEO: updates title + meta/OG/Twitter + canonical per page.
const upsert = (key, keyType, content) => {
  if (content == null || content === "") return;
  let el = document.head.querySelector(`meta[${keyType}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(keyType, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export function setSeo({ title, description, image }) {
  if (title) document.title = title;
  upsert("description", "name", description);
  upsert("og:title", "property", title);
  upsert("og:description", "property", description);
  upsert("og:image", "property", image);
  upsert("og:url", "property", window.location.href);
  upsert("twitter:title", "name", title);
  upsert("twitter:description", "name", description);
  upsert("twitter:image", "name", image);
  const link = document.head.querySelector('link[rel="canonical"]');
  if (link) link.setAttribute("href", window.location.href);
}

export const ogImageUrl = () => `${window.location.origin}/og-image.jpg`;
